import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";

import { axiosGet, axiosPost } from "../../api/Axios";

export const getAllOrdersApi = createAsyncThunk(
  "/admin/orders/getAllOrders",
  async (query: string, { rejectWithValue }) => {
    try {
      const response = await axiosGet<DashboardOrdersApiResponse>(
        `/admin/orders/getAllOrders${query}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const singleOrderDetailsApi = createAsyncThunk(
  "/admin/orders/getOrderDetailsByID",
  async (orderId: string, { rejectWithValue }) => {
    try {
      const response = await axiosGet<UserOrderExtended>(
        `/admin/orders/getOrderDetailsByID?orderId=${orderId}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const assignFormulaToOrderApi = createAsyncThunk(
  "admin/orders/assignFormulaToOrder",
  async (
    assignFormulaToOrderData: IAssignFormulaToOrderApiProp,
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosPost<
        IAssignFormulaToOrderApiProp,
        CreateOrUpdateApisResponse
      >("/admin/orders/assignFormulaToOrder", assignFormulaToOrderData);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState: IOrdersSliceProp = {
  reloadApiCount: 0,
  errors: [],
  isError: false,
  isOrdersApiLoading: true,
  singleOrder: null,
  ordersData: {
    totalPages: 0,
    currentPage: 1,
    previousPage: null,
    nextPage: null,
    totalCount: 0,
    pageSize: 50,
    entries: [],
  },
};

export const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    reloadOrdersApi: (state, action: PayloadAction<boolean>) => {
      state.reloadApiCount++;
    },
    updateOrdersFromSocket: (
      state,
      action: PayloadAction<DashboardOrdersApiResponse>
    ) => {
      state.ordersData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getAllOrdersApi.pending, (state) => {
        state.isOrdersApiLoading = true;
        state.isError = false; // Reset error
      })
      .addCase(getAllOrdersApi.fulfilled, (state, action) => {
        state.isOrdersApiLoading = false;
        state.ordersData = action.payload;
        // state.averagePainRatingData = action.payload;
      })
      .addCase(getAllOrdersApi.rejected, (state, action) => {
        state.isOrdersApiLoading = false;
        state.isError = true; // Handle error message
        state.errors = [action.payload as string];
      })
      .addCase(singleOrderDetailsApi.pending, (state) => {
        state.isOrdersApiLoading = true;
        state.isError = false; // Reset error
      })
      .addCase(singleOrderDetailsApi.fulfilled, (state, action) => {
        state.isOrdersApiLoading = false;
        state.singleOrder = action.payload;
        // state.averagePainRatingData = action.payload;
      })
      .addCase(singleOrderDetailsApi.rejected, (state, action) => {
        state.isOrdersApiLoading = false;
        state.isError = true; // Handle error message
        state.errors = [action.payload as string];
      });
  },
});

export const { reloadOrdersApi, updateOrdersFromSocket } = ordersSlice.actions;

export default ordersSlice.reducer;
